import React from 'react';
import { Container } from '@design-system-etat/dsfr-react';

const MentionsLegales = () => {
    return (
        <Container margeExterne={false}>
            <h1>Mentions légales</h1>
            <h2>Réalisation éditoriale</h2>
            <p className="text-justify">
                Le site du Système d'information sur les armes (SIA) et ses différents portails sont
                édités et gérés par le Service central des armes et explosifs du ministère de
                l'intérieur et des outre-mer :
                <br />
                Ministère de l'Intérieur et des Outre-mer
                <br />
                Service central des armes et explosifs
                <br />
                Place Beauvau 75008 Paris
            </p>
            <h2>Responsable de publication</h2>
            <p className="text-justify">Le chef du Service central des armes et explosifs</p>
            <h2>Fondement juridique</h2>
            <p className="text-justify">
                <ul>
                    <li>
                        Décret n° 2020-487 du 28 avril 2020 portant création d'un traitement
                        automatisé de données à caractère personnel dénommé « système d'information
                        sur les armes »
                    </li>
                    <li>Code de la sécurité intérieure (articles R. 312-84 à R. 312-90)</li>
                    <li>
                        Délibération n° 2020-001 du 09 janvier 2020 portant avis sur un projet de
                        décret portant création d'un traitement automatisé de données à caractère
                        personnel dénommé « système d'information sur les armes »
                    </li>
                </ul>
            </p>
            <h2>Propriété intellectuelle et droits de reproduction</h2>
            <p className="text-justify">
                Le site du système d'information sur les armes est une œuvre de création, propriété
                exclusive du Service central des armes et explosifs du ministère de l'intérieur et
                des outre-mer, protégé par les législations françaises, de l'Union européenne et
                internationale sur le droit de la propriété intellectuelle. Toute reproduction ou
                adaptation, totale ou partielle, des pages du site qui en reprendrait les éléments
                graphiques est strictement interdite. Toute utilisation des contenus à des fins
                commerciales est également interdite. Toute citation ou reprise de contenus du site
                doit avoir obtenu l'autorisation du Service central des armes et explosifs. La
                source des différents portails du système d'information sur les armes et la date de
                la copie devront être indiquées ainsi que le copyright du Service central des armes
                et explosifs.
            </p>
            <h2>Liens hypertextes vers les pages du site</h2>
            <p className="text-justify">
                La mise en place de liens hypertextes par des tiers vers des pages ou des documents
                diffusés sur le site du système d'information sur les armes est autorisée sous
                réserve que les liens ne contreviennent pas aux intérêts du Service central des
                armes et explosifs du ministère de l'intérieur et des outre-mer, et, qu'ils
                garantissent la possibilité pour l'utilisateur d'identifier l'origine et l'auteur du
                document. Les différents portails du système d'information sur les armes ne devront
                pas être imbriqués à l'intérieur des pages d'un autre site. Ils devront être
                affichés dans une nouvelle fenêtre.
            </p>
            <h2>Développement, intégration, hébergement et diffusion</h2>
            <p>
                Direction du Numérique du Ministère de l'Intérieur et des Outre-mer <br /> 40 Avenue
                des Terroirs de France
                <br />
                75012 Paris
            </p>
            <h2>Attestation d&apos;homologation</h2>
            <p className="text-justify">
                Le Service central des armes et explosifs atteste formellement auprès des
                utilisateurs que les applications accessibles via ce portail sont homologuées
                conformément aux prescriptions définies par le référentiel général de sécurité
                (RGS).
            </p>
            <br />
            <p>Ⓒ Ministère de l&apos;intérieur et des Outre-mer - Version : 1.0.0</p>
        </Container>
    );
};

export default MentionsLegales;
